<template>
<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.94141 15.7583H12.6081C14.9081 15.7583 16.7747 13.8917 16.7747 11.5917C16.7747 9.29165 14.9081 7.42499 12.6081 7.42499H3.44141" stroke="#FF8300" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.35794 9.50834L3.22461 7.375L5.35794 5.24167" stroke="#FF8300" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>